import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FormControlLabelStyled = styled(FormControlLabel)(() => ({
	display: 'flex',

	'&.MuiFormControlLabel-labelPlacementStart': {
		marginLeft: 0,
		marginRight: 0,
		justifyContent: 'space-between',
	},
}));
